import { TFunction } from 'i18next';
import {
    IClientSourceOfHireEntry,
    IClientSourceOfHireChartData,
    ISourceOfHirePieSlice,
    ISourceOfHireBar,
    ISourceOfHireStageBar,
} from '../interfaces/reports.interfaces';
import {
    SOURCE_OF_HIRE_DISTRIBUTION_METRICS,
    SOURCE_OF_HIRE_STAGE_METRICS,
} from '../consts/reports.consts';

const sourceOfHireCompactNumberFormatter = new Intl.NumberFormat('en', {
    notation: 'compact',
    maximumFractionDigits: 1,
});

export const formatSourceOfHireAmount = (
    amount: number,
    isPercent: boolean
): string =>
    isPercent
        ? `${Math.round(amount)}%`
        : sourceOfHireCompactNumberFormatter.format(amount);

export const toSourceOfHirePieSlices = (
    entries: IClientSourceOfHireEntry[]
): ISourceOfHirePieSlice[] =>
    entries.map((entry) => ({
        name: entry.sourceTitle,
        value: entry.amount,
        share: entry.amount,
    }));

export const getSourceOfHireSourceTitles = (
    chartData: IClientSourceOfHireChartData
): string[] => {
    const titles: string[] = [];
    SOURCE_OF_HIRE_DISTRIBUTION_METRICS.forEach((option) => {
        chartData[option.metric].forEach((entry) => {
            if (!titles.includes(entry.sourceTitle)) {
                titles.push(entry.sourceTitle);
            }
        });
    });
    return titles;
};

export const getSourceOfHireBarsBySource = (
    entries: IClientSourceOfHireEntry[],
    selectedTitles: string[]
): ISourceOfHireBar[] => {
    const filtered =
        selectedTitles.length > 0
            ? entries.filter((entry) =>
                  selectedTitles.includes(entry.sourceTitle)
              )
            : entries;

    return filtered.map((entry) => ({
        name: entry.sourceTitle,
        value: entry.amount,
    }));
};

export const getSourceOfHireStageBars = (
    chartData: IClientSourceOfHireChartData,
    sourceTitle: string | null,
    t: TFunction
): ISourceOfHireStageBar[] =>
    SOURCE_OF_HIRE_STAGE_METRICS.map((metric) => {
        const entries = chartData[metric];
        const option = SOURCE_OF_HIRE_DISTRIBUTION_METRICS.find(
            (item) => item.metric === metric
        );
        const total = entries.reduce((sum, entry) => sum + entry.amount, 0);
        const value =
            entries.find((entry) => entry.sourceTitle === sourceTitle)
                ?.amount ?? 0;

        return {
            name: option ? t(option.shortLabelKey) : metric,
            value,
            total,
        };
    });
